export const CLIENT_ID = "0ef1a184-d0ff-4de3-ad35-4a1e7977e582";
export const SECRET = "AEr$c$F7SYV";

export const PLATFORM_TYPES = [
    {value: "SOCIAL ADQ", label: "SOCIAL ADQ"},
    {value: "ORGÁNICO", label: "ORGÁNICO"},
    {value: "PROGRAMÁTICA ADQ", label: "PROGRAMÁTICA ADQ"},
    {value: "ADS ADQ", label: "ADS ADQ"}
];

export const PLATFORM_ATTRIBUTIONS = [
    {value: "ATRIBUIDA", label: "ATRIBUIDA"},
    {value: "NO ATRIBUIDA", label: "NO ATRIBUIDA"}
];

export const ENABLED_BOOLS = [
    {value: "true", label: "Activo"},
    {value: "false", label: "Inactivo"}
]

export const GROUPED_CHART_COLOURS = [
    "#0068ff",
    "#d43ddd",
    "#d4d02f",
    "#7d4dff",
    "#09d0c1",
    "#f9b9f2",
    "#255957",
    "#e63462",
    "#f78154",
    "#f2c14e",
    "#5fad56",
    "#4d9078",
    "#35a7ff",
    "#0075a2",
    "#6a3d9a",
    "#e31a1c",
    "#fe5f55",
    "#fdbf6f"
]